export default __webpack_public_path__ + "fea9c65c542635c22bc488026ea34fd9.png";